module.exports = __webpack_public_path__ + "static/media/entry_group_notification_active.31b56f8f.svg";